
import {API_URL as api_url} from "../services/api"
const isProduction = process.env.NODE_ENV === "production";
const API_URL = `${api_url}/web`;
export default API_URL;

export const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const googleApiKey = process.env.REACT_APP_GOOGLE_API_KEY;

export const google_client_id = "1023790924045-svn8flm2r0tn8fpc58n9gqjmfmpi7eut.apps.googleusercontent.com";
export const google_api_key = "AIzaSyClsNfrqz8-tumP4Elm3MX_9qbnYsD0t7A";

export const googleScopes =
  "https://www.googleapis.com/auth/gmail.readonly https://www.googleapis.com/auth/gmail.send https://www.googleapis.com/auth/gmail.modify https://www.googleapis.com/auth/gmail.labels https://www.googleapis.com/auth/gmail.compose https://www.googleapis.com/auth/gmail.insert https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/calendar.events https://www.googleapis.com/auth/userinfo.profile";
export const redirectUrl =
  "https://devbackend-qo6z5qg44q-em.a.run.app/oauth2callback";
export const serverUrl = "https://devbackend-qo6z5qg44q-em.a.run.app";
